"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  id: 1,
  name: "Sarah Jenkins",
  role: "Operations Director",
  content: "The strategic insights and seamless execution completely transformed our operational efficiency. It feels incredibly robust and reliable.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619832/img/avatar_elena.png"
}, {
  id: 2,
  name: "David Park",
  role: "Senior Systems Architect",
  content: "A masterclass in reliable, high-performance architecture. Every component is optimized for speed. Our enterprise uptime has been flawless.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619832/img/avatar_marcus.png"
}, {
  id: 3,
  name: "Rachel Adams",
  role: "CEO & Founder",
  content: "Partnering with this team was a turning point. They understood our complex requirements and delivered a solution that exceeded our goals.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619832/img/avatar_sophia.png"
}, {
  id: 4,
  name: "Michael Torres",
  role: "VP of Strategy",
  content: "The intuitive interface and powerful analytics create a level of transparency we've never had before. It's not just software; it's a growth engine.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619832/img/avatar_james.png"
}];
export default function Testimonials() {
  return <section data-section-id="224872" id="credibility-trust" className="relative overflow-hidden bg-background text-foreground py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 -translate-x-1/2 -translate-y-1/2">
        <div className="h-[400px] w-[800px] rounded-full bg-primary/5 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Trusted by Industry Leaders
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            Join the hundreds of organizations that rely on our expertise to power their critical infrastructure and drive meaningful results.
          </p>
        </div>

        <Carousel opts={{
        align: "start",
        loop: true,
        duration: 40
      }} className="mx-auto w-full max-w-6xl">
          <CarouselContent className="-ml-4 md:-ml-6">
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4 md:basis-1/2 md:pl-6 lg:basis-1/3">
                <div className="h-full p-2">
                  <Card className="group relative h-full overflow-hidden border-border/40 bg-card/40 shadow-lg backdrop-blur-xl transition-all duration-500 hover:-translate-y-2 hover:shadow-xl">
                    <CardContent className="flex h-full flex-col justify-between p-8">
                      {}
                      <span className="absolute left-4 top-4 select-none font-serif text-8xl leading-none text-primary/10" aria-hidden="true">
                        {"{"}
                      </span>
                      <span className="absolute bottom-4 right-4 select-none font-serif text-8xl leading-none text-primary/10" aria-hidden="true">
                        {"}"}
                      </span>

                      <div className="relative z-10 mb-8 pt-6">
                        <p className="font-sans text-lg font-normal leading-relaxed text-foreground/90">
                          {testimonial.content}
                        </p>
                      </div>

                      <div className="relative z-10 mt-auto flex items-center gap-4">
                        <SafeHydrate><Avatar className="size-14 ring-2 ring-primary ring-offset-2 ring-offset-background transition-all duration-500 group-hover:ring-offset-4">
                          <AvatarImage src={testimonial.avatar} alt={testimonial.name} className="scale-105 object-cover grayscale transition-all duration-500 group-hover:scale-100" />
                          <AvatarFallback className="font-default text-lg font-semibold bg-muted text-muted-foreground">
                            {testimonial.name.charAt(0)}
                          </AvatarFallback>
                        </Avatar></SafeHydrate>
                        <div>
                          <h4 className="font-default font-semibold text-foreground">
                            {testimonial.name}
                          </h4>
                          <p className="text-sm text-muted-foreground">
                            {testimonial.role}
                          </p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          <div className="mt-12 flex items-center justify-center gap-6">
            <CarouselPrevious variant="outline" className="static flex size-12 translate-x-0 translate-y-0 items-center justify-center rounded-full border border-primary bg-transparent text-primary transition-all duration-500 hover:scale-110 hover:bg-primary hover:text-primary-foreground" />
            <CarouselNext variant="outline" className="static flex size-12 translate-x-0 translate-y-0 items-center justify-center rounded-full border border-primary bg-transparent text-primary transition-all duration-500 hover:scale-110 hover:bg-primary hover:text-primary-foreground" />
          </div>
        </Carousel>
      </div>
    </section>;
}